import { createFetcher } from '../../Common';

import { getBaseUrl, LETTERHEAD_ENDPOINT } from '../../constants';

export class Letterhead {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Letterhead(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = LETTERHEAD_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getLetterhead() {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }
}

export const createLetterhead = () => Letterhead.getInstance();
